import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { siteRoutingActionCreators } from '../modules/developmentSiteView'

type IDevelopmentSiteRedirectPageProps = typeof siteRoutingActionCreators &
  RouteComponentProps<{ id: string }>

export class DevelopmentSiteRedirectPage extends React.PureComponent<
  IDevelopmentSiteRedirectPageProps
> {
  public componentDidMount() {
    this.props.getSiteRouting(this.props.match.params.id)
  }

  public render() {
    return <div />
  }
}
